// import external dependencies
import 'bootstrap';
import 'jquery';
import './vendor/jquery.easing.min';
import './vendor/modernizr';
import './vendor/history';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singlePost from './routes/single-post';
import singleTeam from './routes/single-team';

// Components
import browser from './components/browser';
import externalLinks from './components/external-links';
import headings from './components/headings';
import ie from './components/ie';
import navigation from './components/navigation';
import scrollReveal from './components/scroll-reveal';
import scrollTo from './components/scroll-to';

// Blocks
import columns from './blocks/columns';
import cover from './blocks/cover';
import form from './blocks/form';
import gallery from './blocks/gallery';
import mediaText from './blocks/media-text';
import paragraph from './blocks/paragraph';
import share from './blocks/share';
import video from './blocks/video';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  singlePost,
  singleTeam,
});

// Init blocks
columns();
cover();
form();
gallery();
mediaText();
paragraph();
share();
video();

// Init components
browser();
externalLinks();
headings();
ie();
navigation();
scrollReveal();
scrollTo();

// Load Events
jQuery(document).ready(() => routes.loadEvents());

/**
 * Add class to body for development
 */
if (window.location.hostname === 'localhost') {
  $('body').addClass('localhost');
}
